import type { QuestionWithSlide } from '@mentimeter/presentation-schema/api-types-overrides';
import { usePresentationContext } from '@mentimeter/question-modules-contexts';
import type { PropsWithChildren } from 'react';
import type { BoxT } from '@mentimeter/ragnar-ui/box';
import { TitleSection, type TitleSectionProps } from './TitleSection';

// Didn't think of all usecases, we will fill them in as we use this component in different modules

export const TitleSectionDataHandler = ({
  children,
  showTextSizeDropdown,
  ...rest
}: PropsWithChildren<
  BoxT & Pick<TitleSectionProps, 'showTextSizeDropdown'>
>) => {
  const { useQuestion } = usePresentationContext();
  const {
    title_meta,
    layout,
    interactiveContents,
    // The 3 below can be removed when we have compat layer support everywhere
    question,
    question_description,
    question_styled,
  } = useQuestion() as QuestionWithSlide;

  const interactiveContent = interactiveContents?.[0];

  return (
    <TitleSection
      question={interactiveContent?.title ?? question}
      questionStyled={question_styled}
      question_description={
        interactiveContent?.description ?? question_description
      }
      title_meta={title_meta}
      fontSizeOffset={layout?.font_size_offset}
      showTextSizeDropdown={showTextSizeDropdown ?? false}
      {...rest}
    >
      {children}
    </TitleSection>
  );
};
